import {
  ELMA365VersionAction,
  ELMA365VersionAvailability,
  ELMA365VersionModel,
  ELMA365VersionPhase,
  ELMA365VersionStage,
  ELMA365VersionStatus,
  ELMA365VersionVisibility,
} from '../../../../../../gamma-api';

export const EMPTY_MERGING_VERSION: ELMA365VersionModel = {
  version_id: '',
  folder_id: '',
  connector_id: '',
  toolset_id: '',
  action: ELMA365VersionAction.Merging,
  status: ELMA365VersionStatus.Processing,
  stage: ELMA365VersionStage.Connector,
  phase: ELMA365VersionPhase.Selection,
  availability: ELMA365VersionAvailability.Enabled,
  visibility: ELMA365VersionVisibility.Visible,
  name: '',
  scheme: { etag: '' },
  problem: null,
};

export const TRANSLATION_GROUP_NAME = 'Toolkits: ELMA365: Merge';
